import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./app/app-router";
import { AuthProvider } from "./app/components/auth/firebase-context";
import { ErrorBoundaryFallback } from "./app/components/error/error-boundary-fallback";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Store from "./store";
import "./i18n/config";
import { validateStringTables } from "./i18n/locUtils";
import PortalNotificationProvider from "./app/components/notifications/context/PortalNotificationProvider";
import PortalNotificationBanner from "./app/components/notifications/components/PortalNotificationBanner";

const container = document.getElementById("root");
const root = createRoot(container!);

if (process.env.NODE_ENV !== "production") {
  validateStringTables();
}

root.render(
  // <React.StrictMode>
  <Provider store={Store}>
    <BrowserRouter>
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={(e) => {
          console.log("ErrorBoundary reset called!", e);
        }}
      >
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
